export const Errors = {
    NET_WORK_ERROR: "Network error",
    GRAPHQL_VALIDATION_FAILED:"An invalid request",
}